'use client'

import {
  Box,
  Stack,
  HStack,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  List,
  ListItem,
  ListIcon,
  Button,
} from '@chakra-ui/react'
import { FaCheckCircle } from 'react-icons/fa'
//import Navbar from '../navbar'
import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";

import { getAuth } from "firebase/auth";

const auth = getAuth();
const user = auth.currentUser;
console.log(auth.currentUser)
if (user !== null) {
  user.providerData.forEach((profile) => {
    console.log("Sign-in provider: " + profile.providerId);
    console.log("  Provider-specific UID: " + profile.uid);
    console.log("  Name: " + profile.displayName);
    console.log("  Email: " + profile.email);
    console.log("  Photo URL: " + profile.photoURL);
  });
}


interface Props {
    children: React.ReactNode
}

function PriceWrapper(props: Props) {
    const { children } = props
  
    return (
      <Box
        mb={4}
        shadow="base"
        borderWidth="1px"
        alignSelf={{ base: 'center', lg: 'flex-start' }}
        borderColor={useColorModeValue('gray.200', 'gray.500')}
        borderRadius={'xl'}>
        {children}
      </Box>
    )
  }

export default function Components() {
    const Navigate = useNavigate();
  return (
    <Box py={1}>
      <VStack spacing={2} textAlign="center">
     
        
      </VStack>
      <Stack
        direction={{ base: 'column', md: 'row' }}
        textAlign="center"
        justify="center"
        spacing={{ base: 4, lg: 10 }}
        py={10}>
        <PriceWrapper>
          <Box py={4} px={12}>
            <Text fontWeight="500" fontSize="2xl">
              Tất cả code của thệ thống
            </Text>
          </Box>
          <VStack
            bg={useColorModeValue('gray.50', 'gray.700')}
            py={4}
            borderBottomRadius={'xl'}>
            <List spacing={3} textAlign="start" px={12}>
              <ListItem>
                Có thể khóa
              </ListItem>
              <ListItem>
                Có thể xóa
              </ListItem>
              <ListItem>
                Có hiện email của ai
              </ListItem>
            </List>
            <Box w="80%" pt={7}>
              <Button w="full" colorScheme="red" variant="outline" onClick={() => {Navigate("/tatcacode");}}>
                vào
              </Button>
            </Box>
          </VStack>
        </PriceWrapper>

        <PriceWrapper>
          <Box position="relative">
            <Box
              position="absolute"
              top="-13px"
              left="50%"
              style={{ transform: 'translate(-50%)' }}>
              <Text
                textTransform="uppercase"
                bg={useColorModeValue('red.300', 'red.700')}
                px={2}
                py={1.1}
                color={useColorModeValue('gray.900', 'gray.300')}
                fontSize="sm"
                fontWeight="600"
                rounded="xl">
                Cảnh báo
              </Text>
            </Box>
            <Box py={4} px={12}>
              <Text fontWeight="500" fontSize="2xl">
                le
              </Text>
            </Box>
            <VStack
              bg={useColorModeValue('gray.50', 'gray.700')}
              py={4}
              borderBottomRadius={'xl'}>
              <List spacing={3} textAlign="start" px={12}>
                <ListItem>
                  lé
                </ListItem>
              </List>
              <Box w="85%" pt={7}>
                <Button w="full" colorScheme="red" onClick={() => {
                    confirmAlert({
                      title: 'Bạn có chắc chắc muốn vào?',
                      message: 'Nó rất nguy hiểm',
                      buttons: [
                        {
                          label: 'Xác nhận',
                          onClick: async () => {

                          }
                        },
                        {
                          label: 'Hủy',
                        }
                      ]
                    });
                  }}>
                  vô và siuuuuuuuuuu
                </Button>
              </Box>
            </VStack>
          </Box>
        </PriceWrapper>
      </Stack>
    </Box>
  )
}